import {useState} from "react";
import styled from 'styled-components';
import {useHistory} from "react-router-dom";

import {Button, FormControl, FormLabel, Input, InputGroup, Stack, useToast} from "@chakra-ui/react";
import {Footer, Fullscreen, Main} from '../../components/fullscreen_view';
import Form from "../../components/form";
import useFeedback from "../../utils/use_feedback";
import ErrorMessage from "../../components/error_message";
import {FixedTopBar} from "../../components/top_bar";
import {useRecover} from "../../api/reset";
import {useQuery} from "../../utils/router";
import {useLoggedIn} from "../../store";

const Description = styled.div``;

const Change = styled(({className}) => {
    const {feedbackCh, error} = useFeedback(true);

    const {token} = useQuery();

    const [newPassword, setNewPassword] = useState();
    const [confirmNewPassword, setConfirmNewPassword] = useState();

    const recover = useRecover(feedbackCh);

    const [status, setStatus] = useState();
    const [loading, setLoading] = useState(false);
    const toast = useToast();
    const loggedIn = useLoggedIn();
    const history = useHistory();
    const handleNext = async () => {
        if (newPassword === confirmNewPassword) {
            try {
                await recover(token, newPassword);
                toast({
                    title: `Password has been reset.`,
                    status: 'success',
                    isClosable: true,
                });
                history.replace(loggedIn ? '/' : '/login');
            } catch (e) {
                setStatus(e.toString());
            }
        } else {
            setStatus('Passwords do not match.');
        }
    };

    return (
        <Fullscreen className={className}>
            <FixedTopBar back title="Set Password" border={false}/>
            <Main>
                <Form autocomplete="off">

                    <Stack spacing={5}>

                        {token ?
                            <>
                                <Description>
                                    In order to reset your password, you must have an email address associated with your
                                    account.
                                </Description>

                                <FormControl>
                                    <FormLabel>New Password</FormLabel>
                                    <Input type="password"
                                           autoComplete="off"
                                           required
                                           onChange={(e) => setNewPassword(e.currentTarget.value)}
                                    />
                                </FormControl>

                                <FormControl>
                                    <FormLabel>Confirm New Password</FormLabel>
                                    <InputGroup>
                                        <Input type="password"
                                               autoComplete="off"
                                               required
                                               onChange={(e) => setConfirmNewPassword(e.currentTarget.value)}
                                        />
                                    </InputGroup>
                                </FormControl>
                            </>
                            :
                            <Description>You must specify a reset token.</Description>
                        }

                    </Stack>

                </Form>
            </Main>
            <Footer>
                <Button mb='12px' variant={"blue"} width={"100%"} onClick={handleNext} isLoading={loading}>Done</Button>
                <ErrorMessage error={status || ""}/>
            </Footer>
        </Fullscreen>
    );
})`

  ${Form} {
    margin-top: 16px;
  }
  
  ${Footer} {
    width: calc(100% - 42px);
    margin: 0 auto;
  }

`;

export default Change;
